import React, { useEffect, useState } from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import Pagination from "react-js-pagination";
import AdminAddTranslationToken from "./AdminAddTranslationToken";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";
import deleteIcon from "~/assets/icons/delete.png";
import {EditIcon} from "~/Components/Icons/Icons";
import AdminEditTranslationToken from "./AdminEditTranslationToken";

const AdminTranslationTokens = ({match, event, ...props}) => {

    const [response, setResponse] = useState({});

    const loadData = (page = 1) => {
        adminHttp
            .get('/translation-tokens?page=' + page)
            .then(res => setResponse(res.data));
    };

    useEffect(loadData, [event]);

    const handleDelete = (id) => {
        adminHttp
            .delete('/translation-tokens/' + id)
            .then(res => loadData());
    };

    return (
        <div className="languages">
            <div className="row">
                <div className="col-8">
                    <h2>Translation Tokens</h2>
                </div>
                <div className="col-4 text-right">
                    <AdminAddTranslationToken
                        onChange={loadData}
                        className="btn btn-primary btn-sm">Add Token</AdminAddTranslationToken>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <table className="table">

                                <thead>
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Token</th>
                                    <th scope="col">Value</th>
                                    <th scope="col"></th>
                                </tr>
                                </thead>

                                <tbody>
                                {response.data?.map((token) => (
                                    <tr key={token.id}>
                                        <td>{token.id}</td>
                                        <td>[{token.token}]</td>
                                        <td>
                                            <div dangerouslySetInnerHTML={{__html: token.value}}></div>
                                        </td>
                                        <td>

                                            <ConfirmedLink className="cursor-pointer float-right" onClick={() => handleDelete(token.id)}>
                                                <img src={deleteIcon}/>
                                            </ConfirmedLink>

                                            <AdminEditTranslationToken token={token} onChange={loadData} className="cursor-pointer float-right mr-2">
                                                <EditIcon />
                                            </AdminEditTranslationToken>

                                        </td>
                                    </tr>
                                ))}
                                </tbody>

                            </table>
                            {response.per_page < response.total && (
                                <Pagination
                                    activePage={response.current_page}
                                    itemsCountPerPage={response.per_page}
                                    totalItemsCount={response.total}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    onChange={loadData}
                                />
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    event: state.event.current,
});

export default connect(mapStateToProps)(AdminTranslationTokens);
